import React, {useEffect} from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from 'react-redux';
import routes from "../routes/routeSalesOperator";
// import WohlerLogo from "assets/img/wohler_logo_295x117.png";
import WohlerLogo from "assets/img/mavric_logo_new.png";
import WohlerShortLogo from "assets/img/dashboard/wohler.png";
import MDrawer from 'layouts/m-drawer.js'; 
import store from "components/store";

export default function SalesOperatorRole({ ...rest }) {
  let selectedTile = "";
  if(rest !== undefined && rest.location !== undefined && rest.location.state !== undefined){
    selectedTile = rest.location.state.name;
  }
  const { role } = store.getState();

  const isAuthUser  = useSelector(state => state.isAuthUser);
  const Role        = useSelector(state => state.role);
  const UserId      = useSelector(state => state.userid);
  console.log("Accounting Page Role : ", role);
  const isSalesOperator = (Role === "salesoperator") ? true : false;
  console.log("isSalesOperator Role : ", isSalesOperator);
  
  let history = useHistory();
  
  
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();
  
  if(!isSalesOperator) {
    history.push('/login');
  }

  return (
    <div>
     
      {<MDrawer 
        routes={routes}
        logo={WohlerLogo}
        slogo={WohlerShortLogo}
        preSelected={selectedTile}
      />}
      
        
    </div>
  );
}